import { BankAccountDetails } from '@/types/bankAccounts';
import { SVLabeledText, SVSummaryCard } from '../core';
import { SVSummaryCardItem } from '@/types/common';
import { formatCurrency } from '@/utils/currency';
import { Card, Grid, Typography } from '@mui/material';
import { formatDateTimeFromUTC } from '@/utils/date';

type BankAccountDetailsFeesProps = {
  accountDetails: BankAccountDetails;
};

export default function BankAccountDetailsFees({
  accountDetails,
}: BankAccountDetailsFeesProps) {
  const { incomingDomestic, outgoingDomestic, monthlySavingAccount } =
    accountDetails.fees;
  const incomingFee = Number(incomingDomestic.value);
  const outgoingFee = Number(outgoingDomestic.value);
  const savingsFee = Number(monthlySavingAccount.value);

  const items: SVSummaryCardItem[] = [
    {
      label: 'Incoming Domestic',
      text: incomingFee ? formatCurrency({ amount: incomingFee }) : 'N/A',
      size: { xs: 12, md: 4 },
    },
    {
      label: 'Outgoing Domestic',
      text: outgoingFee ? formatCurrency({ amount: outgoingFee }) : 'N/A',
      size: { xs: 12, md: 4 },
    },
    {
      label: 'Monthly Savings Account',
      text: savingsFee ? formatCurrency({ amount: savingsFee }) : 'N/A',
      size: { xs: 12, md: 4 },
    },
  ];

  const exceptionLimitCards = [
    {
      label: 'Check Issuing Exception Limit',
      value: accountDetails?.checkIssuanceOverrideLimit?.value,
      date: accountDetails.checkIssuanceOverrideLimitExpiredAt,
    },
    {
      label: 'Wire Controls',
      value: accountDetails?.wireOutOverrideLimit?.value,
      date: accountDetails.wireOutOverrideLimitExpiredAt,
    },
    {
      label: 'Mobile Check Deposit Controls',
      value: accountDetails?.checkDepositOverrideLimit?.value,
      date: accountDetails.checkDepositOverrideLimitExpiredAt,
    },
    {
      label: 'ACH Credit Exception Controls',
      value: accountDetails?.achCreditOverrideLimit?.value,
      date: accountDetails.achCreditOverrideLimitExpiredAt,
    },
    {
      label: 'ACH Debit Exception Controls',
      value: accountDetails?.achDebitOverrideLimit?.value,
      date: accountDetails.achDebitOverrideLimitExpiredAt,
    },
  ].filter(item => item.value !== undefined);

  return (
    <>
      <SVSummaryCard label="Fees" items={items} />
      {exceptionLimitCards.map(exception => (
        <Card key={exception.label}>
          <Typography variant="h5" mb={2}>
            {exception.label}
          </Typography>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <SVLabeledText
                label="Exception Limit"
                text={formatCurrency({ amount: exception.value || '' })}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <SVLabeledText
                label="Expires At"
                text={formatDateTimeFromUTC(exception.date)}
              />
            </Grid>
          </Grid>
        </Card>
      ))}
    </>
  );
}
